import { useQuery } from '@tanstack/react-query';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';

import { SuggestedDataFetchParams, SuggestedSearchParams, Suggestion } from './types';

const MAX_SUGGESTION_QUERY_LENGTH = 250;

const fetchSuggestions = async (params: SuggestedDataFetchParams) => {
  const response = await api.post(`/search/${params.ver}/${params.system_model}/suggest`, params);
  return response.data;
};

const useSuggestions = (params: SuggestedSearchParams) => {
  const { ver, system_model } = useVersionInfo();
  return useQuery<Suggestion[]>({
    queryKey: ['suggest', params],
    queryFn: () => fetchSuggestions({ ...params, ver, system_model }),
    enabled: !!params.query && params.query.length < MAX_SUGGESTION_QUERY_LENGTH,
  });
};

export default useSuggestions;
